import { AxiosHttpPost } from 'axios-http';
import { OrderCartDTO } from 'models/spareParts/orderById';
import { SPARE_PARTS } from 'resources/links';
import Cookies from 'universal-cookie';

export function createOrder(order: OrderCartDTO) {
    const header = { 'Content-Type': 'application/json', Accept: '*/*', /*Authorization: `Bearer ${new Cookies().get('inf-o')}`*/ };
    return AxiosHttpPost({ url: SPARE_PARTS.createOrder, headers: header, data: order });
}
